/**
 * ════════════════════════════════════════════════════════════════════
 * KEEP MEMORIZ — assets/km-legal-translate.js
 * Traduit les 4 pages légales FR → EN
 * Pages : mentions-legales, conditions-generales-de-vente,
 *         confidentialite, politique-de-remboursement
 * ════════════════════════════════════════════════════════════════════
 */
(function () {
  var lang = (window.KM_LANG || 'fr').toLowerCase();
  if (lang === 'fr') return;

  var path = window.location.pathname.replace(/^\/en/, '');

  var PAGES = {

    '/pages/mentions-legales': {
      heroTag: '✦ Legal Information',
      heroTitle: 'Legal <em>Notice</em>',
      heroMeta: ['Last updated: March 2025', 'Jurisdiction: Dubai, United Arab Emirates', 'Applicable law: Federal Decree-Law No. 14/2023'],
      sections: [
        {
          title: '1. Publisher Identity',
          content: '<p>In accordance with the disclosure requirements of the Federal Decree-Law No. 14 of 2023 Concerning Trade Through Modern Technology Means (UAE E-Commerce Law) and Federal Law No. 15 of 2020 on Consumer Protection, the following information is made available to all users and buyers.</p><h3>Company</h3><p><strong>Legal name:</strong> KeepMemoriz FZ-LLC<br><strong>Legal form:</strong> Free Zone Limited Liability Company</p><div class="km-legal-notice"><strong>Note:</strong> Under Article 6 of Federal Decree-Law No. 14/2023, all electronic traders are required to disclose their license number, issuing authority, and full contact details to competent authorities and consumers.</div><h3>Contact</h3><p><strong>Website:</strong> www.keepmemoriz.com<br><strong>General email:</strong> contact@keepmemoriz.com<br><strong>Customer service email:</strong> contact@keepmemoriz.com<br><strong>Service languages:</strong> French (primary) · English (available)</p>'
        },
        {
          title: '2. Website Hosting',
          content: '<p>The website www.keepmemoriz.com is hosted by:</p><p><strong>Shopify Inc.</strong><br>151 O\'Connor Street, Ground floor<br>Ottawa, Ontario, K2P 2L8, Canada<br>Website: www.shopify.com</p><p>Technical browsing data (server logs, IP addresses) is processed by Shopify in accordance with its own privacy policy.</p>'
        },
        {
          title: '3. Nature of Activity',
          content: '<p>KeepMemoriz operates an online store offering digital event photo gallery services for individuals and professionals worldwide.</p><p>Products sold are <strong>digital goods / online access services</strong>: private photo galleries with personalized QR codes, delivered immediately by electronic means.</p><p><strong>Sector:</strong> E-commerce of digital products (international B2C)<br><strong>Product codes:</strong> Digital media storage and sharing services</p><p><strong>International trade:</strong> KeepMemoriz sells exclusively internationally. Transactions are concluded in euros (EUR). Applicable VAT depends on the buyer\'s country of residence in accordance with applicable international tax rules.</p>'
        },
        {
          title: '4. Intellectual Property',
          content: '<p>All elements composing the website www.keepmemoriz.com — texts, graphics, logos, icons, images, videos, sounds, databases, software and source code — are the exclusive property of KeepMemoriz FZ-LLC or its partners and content providers, and are protected by applicable intellectual property laws, including:</p><ul><li>Federal Law No. 38 of 2021 on Copyrights and Related Rights (UAE)</li><li>International Berne and Paris Conventions on Intellectual Property</li><li>Federal Decree-Law No. 14/2023 protecting intellectual property rights in e-commerce transactions</li></ul><p>Any reproduction, representation, modification, publication, transmission, distortion, in whole or in part, of the website or its content, by any means whatsoever, and on any medium, is strictly prohibited without prior written authorization from KeepMemoriz FZ-LLC.</p><p>Failure to comply constitutes counterfeiting that may incur civil and criminal liability under UAE laws and applicable international conventions.</p>'
        },
        {
          title: '5. Hyperlinks',
          content: '<p>The website www.keepmemoriz.com may contain links to third-party websites. These links are provided for informational purposes only. KeepMemoriz FZ-LLC exercises no control over these sites and disclaims all responsibility for their content, privacy practices, or availability.</p><p>Any hyperlink pointing to the KeepMemoriz website must be subject to prior written authorization.</p>'
        },
        {
          title: '6. Applicable Law and Jurisdiction',
          content: '<p>These legal notices are governed by the law of the United Arab Emirates, in particular the law applicable in the Emirate of Dubai.</p><p>In the event of a dispute relating to the interpretation or execution of these notices, the parties shall endeavor to resolve the dispute amicably. Failing that, the competent courts of Dubai (UAE) shall have exclusive jurisdiction, unless mandatory provisions applicable in the consumer\'s country of residence provide otherwise.</p><p>In accordance with Federal Law No. 15/2020 on Consumer Protection, consumers retain the benefit of mandatory protective provisions of their national law where these are more favorable to them.</p><div class="km-legal-notice"><strong>Reference texts:</strong> Federal Decree-Law No. 14/2023 (E-Commerce) · Federal Law No. 15/2020 (Consumer Protection) · Cabinet Decision No. 66/2023 (Executive Regulations) · Federal Decree-Law No. 45/2021 (Personal Data Protection) · Federal Law No. 38/2021 (Copyright)</div>'
        },
        {
          title: '7. Contact',
          content: '<p>For any questions regarding these legal notices or the exercise of your rights:</p>'
        }
      ],
      contact: [
        { label: 'Legal email', value: 'contact@keepmemoriz.com' },
        { label: 'Customer service', value: 'contact@keepmemoriz.com' },
        { label: 'Postal address', value: 'KeepMemoriz FZ-LLC<br>Dubai, UAE' },
        { label: 'Response time', value: 'Within 5 business days' }
      ]
    },

    '/pages/conditions-generales-de-vente': {
      heroTag: '✦ Contractual terms',
      heroTitle: 'General Terms<br>of <em>Sale</em>',
      heroMeta: ['Version: 2.0 — March 2025', 'Applicable law: UAE (Dubai)', 'International sales'],
      sections: [
        {
          title: 'Preamble',
          content: '<p>These General Terms of Sale (hereinafter "GTS") govern all sales of digital products and services offered by KeepMemoriz FZ-LLC through the website www.keepmemoriz.com. By placing an order, the Customer acknowledges having read and accepted these GTS without reservation.</p>'
        },
        {
          title: 'Article 1 — Purpose and Scope',
          content: '<p>These GTS define the rights and obligations of KeepMemoriz FZ-LLC ("the Seller") and any person making a purchase on the website ("the Customer"). They apply to all orders placed through the website, regardless of the Customer\'s country of residence.</p>'
        },
        {
          title: 'Article 2 — Contract Formation',
          content: '<p>The order is considered final after the Customer has completed the following steps: choosing the product, customizing the QR code poster, filling in the required information, and confirming payment. An order confirmation email is automatically sent to the Customer.</p>'
        },
        {
          title: 'Article 3 — Price and Payment Terms',
          content: '<p>Prices are displayed in euros (EUR), all taxes included. Payment is made online by credit card, PayPal, Apple Pay, or any other payment method available on the site. Payment is processed securely via Shopify Payments. No bank details are stored by KeepMemoriz.</p>'
        },
        {
          title: 'Article 4 — Delivery of Digital Products',
          content: '<p>Products sold are digital services delivered immediately by email after payment confirmation. The Customer receives an access link to their private photo gallery and a downloadable personalized QR code poster. Delivery is considered effective upon sending the confirmation email.</p>'
        },
        {
          title: 'Article 5 — Warranty and Compliance',
          content: '<p>KeepMemoriz guarantees that the digital services provided conform to the description on the website. The gallery is accessible for 6 months from the date of creation. In case of a technical malfunction preventing access to the gallery, KeepMemoriz will make every effort to restore access as soon as possible.</p>'
        },
        {
          title: 'Article 6 — Right of Withdrawal and Refund',
          content: '<p>In accordance with applicable consumer protection regulations, and given the digital nature of the products sold, the Customer is informed that the right of withdrawal does not apply once the digital service has been fully provided. However, KeepMemoriz offers a <strong>30-day satisfaction guarantee</strong>: if the Customer is not satisfied, a full refund will be issued upon request, with no conditions or justification required.</p>'
        },
        {
          title: 'Article 7 — Customer Obligations',
          content: '<p>The Customer agrees to: provide accurate and up-to-date information when placing the order, use the service in compliance with applicable laws, not share their access with unauthorized third parties, and download their photos and videos before the gallery expiration date.</p>'
        },
        {
          title: 'Article 8 — Liability',
          content: '<p>KeepMemoriz shall not be held liable for: damages resulting from improper use of the service by the Customer, content uploaded by the Customer\'s guests to the gallery, unavailability of the service due to maintenance or events beyond its control, or loss of data after the gallery expiration period.</p>'
        },
        {
          title: 'Article 9 — Force Majeure',
          content: '<p>KeepMemoriz shall not be held liable for any delay or failure in performance resulting from events beyond its reasonable control, including but not limited to natural disasters, government actions, internet outages, or cyberattacks.</p>'
        },
        {
          title: 'Article 10 — Personal Data Protection',
          content: '<p>Personal data collected during the order process is processed in accordance with the Federal Decree-Law No. 45/2021 on Personal Data Protection (UAE) and applicable international regulations. For more information, please refer to our <a href="/pages/confidentialite">Privacy Policy</a>.</p>'
        },
        {
          title: 'Article 11 — Applicable Law and Disputes',
          content: '<p>These GTS are governed by the laws of the United Arab Emirates, specifically the law applicable in the Emirate of Dubai. In the event of a dispute, the parties shall first seek an amicable resolution. Failing that, the competent courts of Dubai shall have exclusive jurisdiction, subject to mandatory consumer protection provisions in the Customer\'s country of residence.</p>'
        }
      ]
    },

    '/pages/confidentialite': {
      heroTag: '✦ Privacy',
      heroTitle: 'Privacy <em>Policy</em>',
      heroMeta: ['Last updated: March 2025', 'PDPL Compliant (UAE)', 'International scope'],
      sections: [
        {
          title: '1. Data Controller',
          content: '<p><strong>KeepMemoriz FZ-LLC</strong> is the data controller for personal data collected through the website www.keepmemoriz.com. Contact: contact@keepmemoriz.com</p>'
        },
        {
          title: '2. Data Collected',
          content: '<p>We collect the following personal data:</p><ul><li><strong>Order data:</strong> first name, last name, email address, event name, poster choice</li><li><strong>Payment data:</strong> processed securely by Shopify Payments — we do not store your bank details</li><li><strong>Technical data:</strong> IP address, browser type, device type, pages visited</li><li><strong>Gallery data:</strong> photos and videos uploaded by the Customer\'s guests</li></ul>'
        },
        {
          title: '3. Purpose of Processing',
          content: '<p>Your personal data is processed for the following purposes:</p><ul><li>Processing and delivering your order</li><li>Managing your photo gallery</li><li>Customer support</li><li>Sending order and service-related emails</li><li>Improving our services and website</li><li>Complying with legal obligations</li></ul>'
        },
        {
          title: '4. Legal Basis',
          content: '<p>Data processing is based on: the performance of the contract (order processing), your consent (cookies, marketing), our legitimate interests (service improvement, fraud prevention), and compliance with legal obligations.</p>'
        },
        {
          title: '5. Data Retention',
          content: '<p>Personal data is retained for the duration necessary to fulfill the purposes described above. Gallery data (photos and videos) is retained for 6 months from creation, then permanently deleted. Order data is retained for 5 years for accounting and legal purposes.</p>'
        },
        {
          title: '6. Data Sharing',
          content: '<p>Your personal data may be shared with: Shopify Inc. (hosting and payment processing), email service providers (order communications), and competent authorities when required by law. We never sell your personal data to third parties.</p>'
        },
        {
          title: '7. Your Rights',
          content: '<p>In accordance with the Federal Decree-Law No. 45/2021 on Personal Data Protection and applicable international regulations, you have the right to:</p><ul><li>Access your personal data</li><li>Rectify inaccurate data</li><li>Request deletion of your data</li><li>Object to processing</li><li>Data portability</li><li>Withdraw your consent at any time</li></ul><p>To exercise your rights, contact us at: <strong>contact@keepmemoriz.com</strong></p>'
        },
        {
          title: '8. Cookies',
          content: '<p>Our website uses cookies to improve your browsing experience. You can manage your cookie preferences at any time through the cookie banner displayed on the site. For more information, refer to our cookie settings.</p>'
        },
        {
          title: '9. Data Security',
          content: '<p>We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, loss, or alteration. All data transmissions are encrypted via SSL/TLS protocol.</p>'
        },
        {
          title: '10. Contact',
          content: '<p>For any questions regarding this privacy policy or the processing of your personal data, contact us at: <strong>contact@keepmemoriz.com</strong></p>'
        },
        {
          title: '10. Protection of Minors',
          content: '<p>Our services are intended for adults. We do not knowingly collect personal data from persons under 18 years of age without the consent of their parents or legal guardians, in accordance with UAE PDPL and applicable international regulations.</p><p>If you believe a minor has provided us with personal data, please contact us immediately at contact@keepmemoriz.com and we will delete it as soon as possible.</p>'
        },
        {
          title: '11. Policy Changes',
          content: '<p>KeepMemoriz reserves the right to modify this privacy policy at any time, in particular to comply with legislative or regulatory changes. The "last updated" date at the top of this document indicates the version in effect.</p><p>In the event of a substantial change, we will inform you by email or by a visible notification on the site before the changes take effect. Continued use of the site after modification constitutes acceptance of the new policy.</p>'
        },
        {
          title: 'Contact and DPO',
          content: '<p>For any questions regarding your personal data or the exercise of your rights:</p>'
        }
      ],
      contact: [
        { label: 'Privacy email', value: 'contact@keepmemoriz.com' },
        { label: 'Response time', value: '30 days maximum' },
        { label: 'Postal address', value: 'KeepMemoriz FZ-LLC<br>Attn: DPO Dubai, UAE' },
        { label: 'Competent authority UAE', value: 'UAE Data Office<br>dataoffice.ae' }
      ]
    },

    '/pages/politique-de-remboursement': {
      heroTag: '✦ Refund guarantee',
      heroTitle: 'Refund <em>Policy</em>',
      heroMeta: ['Applicable from: March 2025', '30-day guarantee', 'No conditions'],
      sections: [
        {
          title: '1. Our Commitment',
          content: '<p>At KeepMemoriz, your satisfaction is our priority. We offer a <strong>30-day satisfaction guarantee</strong> on all our products. If KeepMemoriz does not meet your expectations, we will refund you in full — no conditions, no questions asked.</p>'
        },
        {
          title: '2. Eligibility',
          content: '<p>All customers who have purchased a product on www.keepmemoriz.com are eligible for a refund within 30 days of purchase. This guarantee applies regardless of the reason: dissatisfaction, change of plans, cancellation of the event, or any other reason.</p>'
        },
        {
          title: '3. How to Request a Refund',
          content: '<p>To request a refund, simply contact us by email at <strong>contact@keepmemoriz.com</strong> with your order number. No justification is required. Our team will process your request within 48 business hours.</p>'
        },
        {
          title: '4. Refund Processing',
          content: '<p>Once your request is confirmed, the refund will be issued to your original payment method. Processing time depends on your bank or payment provider, typically 5 to 10 business days.</p>'
        },
        {
          title: '5. After the Refund',
          content: '<p>After the refund is processed, access to your photo gallery will be deactivated. We recommend downloading all your photos and videos before requesting a refund.</p>'
        },
        {
          title: '6. Contact',
          content: '<p>For any questions regarding our refund policy:<br><strong>Email:</strong> contact@keepmemoriz.com<br><strong>Response time:</strong> within 24 business hours</p>'
        },
        {
          title: '7. Disputes and Remedies',
          content: '<p>In case of disagreement with a refund decision, you may:</p><ul><li>Escalate your request to our customer service manager at: <strong>contact@keepmemoriz.com</strong></li><li>Contact consumer protection authorities in your country of residence</li><li>For UAE customers: file a complaint with the <strong>Ministry of Economy UAE</strong> (Consumer Protection Department)</li><li>For EU customers: use the ODR platform: <strong>ec.europa.eu/consumers/odr</strong></li><li>Refer to the competent courts in your country of residence if mandatory local provisions allow it</li></ul>'
        }
      ],
      promiseCards: [
        { title: '30 days', desc: 'Satisfaction guaranteed or your money back, no conditions' },
        { title: 'Fast', desc: 'Refund processed within 5 to 10 business days' },
        { title: 'Simple', desc: 'One email is all it takes, no physical return required' }
      ],
      contact: [
        { label: 'Refund request', value: 'contact@keepmemoriz.com' },
        { label: 'Dispute / Escalation', value: 'contact@keepmemoriz.com' },
        { label: 'Processing time', value: 'Acknowledgment 48h<br>Refund 5–10 days' },
        { label: 'Legal basis', value: 'Federal Law No. 15/2020 UAE<br>Cabinet Decision No. 66/2023<br>Directive 2011/83/EU (EU customers)' }
      ]
    }
  };

  /* ══════════ APPLICATION ══════════ */
  var pageData = PAGES[path];
  if (!pageData) return;

  // Hero
  var tag = document.querySelector('.km-legal-tag');
  if (tag) tag.textContent = pageData.heroTag;

  var h1 = document.querySelector('.km-legal-hero h1');
  if (h1) h1.innerHTML = pageData.heroTitle;

  if (pageData.heroMeta) {
    var metaEl = document.querySelector('.km-legal-hero-meta');
    if (metaEl) {
      metaEl.innerHTML = pageData.heroMeta.map(function (m) {
        return '<span>' + m + '</span>';
      }).join('\n');
    }
  }

  // Sections
  if (pageData.sections) {
    var sectionEls = document.querySelectorAll('.km-legal-body section');
    pageData.sections.forEach(function (s, i) {
      if (!sectionEls[i]) return;
      var h2 = sectionEls[i].querySelector('h2');
      if (h2) h2.textContent = s.title;
      // Replace content after h2, but preserve contact blocks
      if (s.content) {
        var contactBlock = sectionEls[i].querySelector('[class*="contact"], [class*="legal-contact"]');
        var children = Array.from(sectionEls[i].children);
        children.forEach(function (child) {
          if (child !== h2 && child !== contactBlock) sectionEls[i].removeChild(child);
        });
        // Insert translated content before the contact block (if it exists)
        var temp = document.createElement('div');
        temp.innerHTML = s.content;
        if (contactBlock) {
          while (temp.firstChild) {
            sectionEls[i].insertBefore(temp.firstChild, contactBlock);
          }
        } else {
          while (temp.firstChild) {
            sectionEls[i].appendChild(temp.firstChild);
          }
        }
      }
    });
  }

  // Contact block - search broadly for contact grid items
  if (pageData.contact) {
    // Try multiple selectors
    var contactItems = document.querySelectorAll('.km-legal-contact-item');
    if (contactItems.length === 0) {
      // Fallback: look inside any dark contact grid
      var contactGrid = document.querySelector('[class*="legal-contact"], [class*="km-contact-grid"]');
      if (contactGrid) contactItems = contactGrid.children;
    }
    if (contactItems.length > 0) {
      pageData.contact.forEach(function (c, i) {
        if (!contactItems[i]) return;
        var strong = contactItems[i].querySelector('strong');
        if (strong) strong.textContent = c.label;
        // Replace ALL text content after strong
        var textNodes = [];
        var walker = document.createTreeWalker(contactItems[i], NodeFilter.SHOW_ELEMENT);
        while (walker.nextNode()) {
          var node = walker.currentNode;
          if (node.tagName === 'SPAN' || (node.tagName === 'A' && !node.querySelector('strong'))) {
            textNodes.push(node);
          }
        }
        if (textNodes.length > 0) {
          textNodes[0].innerHTML = c.value;
        }
      });
    }
  }

  // Promise cards (refund page: "30 jours", "Rapide", "Simple")
  if (pageData.promiseCards) {
    var cards = document.querySelectorAll('.km-promise-card');
    pageData.promiseCards.forEach(function (c, i) {
      if (!cards[i]) return;
      var title = cards[i].querySelector('.km-promise-title');
      if (title) title.textContent = c.title;
      var desc = cards[i].querySelector('.km-promise-desc');
      if (desc) desc.textContent = c.desc;
    });
  }

})();